/** Bantuan WebGL2 generik: kompilasi shader & link program. Tanpa logika orb. */

function compileShader(
	gl: WebGL2RenderingContext,
	type: number,
	source: string,
): WebGLShader {
	const shader = gl.createShader(type);
	if (!shader) throw new Error("gl.createShader gagal (konteks tak valid)");
	gl.shaderSource(shader, source);
	gl.compileShader(shader);
	if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
		const log = gl.getShaderInfoLog(shader);
		gl.deleteShader(shader);
		throw new Error(`Shader gagal dikompilasi: ${log}`);
	}
	return shader;
}

/** Kompilasi + link satu program dari sumber vertex & fragment. */
export function compileProgram(
	gl: WebGL2RenderingContext,
	vertexSrc: string,
	fragmentSrc: string,
): WebGLProgram {
	const vertex = compileShader(gl, gl.VERTEX_SHADER, vertexSrc);
	const fragment = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);
	const program = gl.createProgram();
	if (!program) throw new Error("gl.createProgram gagal (konteks tak valid)");
	gl.attachShader(program, vertex);
	gl.attachShader(program, fragment);
	gl.linkProgram(program);
	if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
		const log = gl.getProgramInfoLog(program);
		throw new Error(`Program gagal di-link: ${log}`);
	}
	return program;
}
